module.exports = __webpack_public_path__ + "img/no_conversations.48a3b5c8.svg";